import BreakoutModuleNarrow from './BreakoutModuleNarrow'

export default BreakoutModuleNarrow
